import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=fa5a5480&"
import script from "./Address.vue?vue&type=script&lang=js&"
export * from "./Address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa5a5480')) {
      api.createRecord('fa5a5480', component.options)
    } else {
      api.reload('fa5a5480', component.options)
    }
    module.hot.accept("./Address.vue?vue&type=template&id=fa5a5480&", function () {
      api.rerender('fa5a5480', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/Address.vue"
export default component.exports